import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { careersEndpoints } from '@/modules/careers/constants';
import type { JobApplicationRequestApi } from '@/modules/careers/types';

interface SubmitJobApplicationInput {
  jobId: string;
  body: JobApplicationRequestApi;
}

export const useSubmitJobApplicationMutation = () =>
  useMutation({
    mutationFn: async ({ jobId, body }: SubmitJobApplicationInput) => {
      await fetchClient.POST(careersEndpoints.applications, {
        params: { path: { jobId } },
        body,
      });
    },
  });
